import { ref } from "vue";
import { defineStore } from "pinia";

export interface OnlineUser {
    id: string;
    name: string;
    email: string;
    role: string;
    last_activity_at?: number | null;
    online?: boolean;
}

export const useOnlineStore = defineStore("online", () => {
    const users = ref<OnlineUser[]>([]);
    const isConnected = ref(false);

    const addUser = (user: OnlineUser) => {
        const exists = users.value.some((u) => u.id === user.id);
        if (!exists) {
            users.value.push(user);
        }
    };

    const removeUser = (userId: string) => {
        users.value = users.value.filter((u) => u.id !== userId);
    };

    const setUsers = (userList: OnlineUser[]) => {
        users.value = userList;
    };

    const clearUsers = () => {
        users.value = [];
    };

    const updateActivity = (userId: string, lastActivity: number) => {
        const user = users.value.find((u) => u.id === userId);
        if (user) {
            user.last_activity_at = lastActivity;
        }
    };

    const totalOnline = () => users.value.length;

    const onlineByRole = () => {
        const counts = {
            student: 0,
            teacher: 0,
            administrator: 0,
            "super-administrator": 0,
        };

        users.value.forEach((user) => {
            const role = user.role;
            if (role in counts) {
                counts[role as keyof typeof counts]++;
            }
        });

        return counts;
    };

    return {
        users,
        isConnected,
        addUser,
        removeUser,
        setUsers,
        clearUsers,
        updateActivity,
        totalOnline,
        onlineByRole,
    };
});
